<template>
  <b-row>
    <b-col md="9">
      <b-card no-body>
        <b-card-header v-b-modal.infoBox class="border-0 pt-8" >
          <div>
            <span v-label-key="'REPORTS_KEY_METRICS'">Key Metrics</span>
            <i class="fa fa-info-circle ml-2" />
          </div>
          <!-- <div @click.stop>
            <b-button
              size="sm"
              variant="outline-primary"
              @click="downloadAll()"
              :disabled="reportDataLoading"
            >
              <i
                v-if="reportDataLoading"
                class="fas fa-spinner reports-list__spinner-icon--rotate"
              />
              <i v-else class="fa fa-download" />&nbsp;
              <span v-label-key="'REPORTS_DOWNLOAD_ALL'">Download All</span>
            </b-button>
          </div> -->
          <!-- Start of Keymetrics Info modal -->
          <b-modal id="infoBox" :title="getLabel('INFO')" ok-only>
            <p class="my-4">
              <span v-label-key="'REPORTS_INFO_TOTAL_COMPLETED_CUTS'"
                >Total Completed Cuts = CUT_CONFIRMED + CUT_SUCCESS.</span
              >
              <br />
              <span v-label-key="'REPORTS_INFO_CONFIRMED_CUTS'"
                >CUT_CONFIRMED – User has confirmed to cut and the cutting
                instructions was sent completely to the machine and the cutting
                process is done.</span
              >
              <br />
              <span v-label-key="'REPORTS_INFO_SUCCESS_CUTS'"
                >CUT_SUCCESS - User has confirmed that the cut was
                successful.</span
              >
            </p>
          </b-modal>
          <!-- End of Keymetrics Info modal -->
        </b-card-header>
        <b-card-body class="keymetrics">
          <div>
            <h1 class="display-1 d-none d-lg-inline-block">
              {{ totalCuts }}
            </h1>
            <h1 class="display-4 d-none d-md-inline-block d-lg-none">
              {{ totalCuts }}
            </h1>
            <h4 class="d-md-none">
              {{ totalCuts }}
            </h4>
            <p v-label-key="'TOTAL_COMPLETED_CUTS'">Total Completed Cuts</p>
          </div>
          <div>
            <h1 class="display-1 d-none d-lg-inline-block">
              {{ cutsPerDay }}
            </h1>
            <h1 class="display-4 d-none d-md-inline-block d-lg-none">
              {{ cutsPerDay }}
            </h1>
            <h4 class="d-md-none">
              {{ cutsPerDay }}
            </h4>
            <p v-label-key="'CUTS_PER_DAY'">Cuts Per Day</p>
          </div>
        </b-card-body>
      </b-card>
      <!-- eslint-disable -->
      <b-card
        no-body
        v-for="(value, key, index) in reportTypes"
        :key="`report_${index}${renderIndex}`"
        class="mt-3 mb-2"
      >
        <template v-if="value.level === undefined || value.level < level">
          <b-card-header
            class="pointer"
            v-b-tooltip.hover="{ customClass: 'toolTipLineBreak' }"
            :title="reportExplanation(value)"
            @click="reportToggleExpand(key)"
          >
            <div>
              {{ reportName(value) }}
              <span v-if="value.limit"> {{ topXLabel(value.limit) }}</span>
              <i class="fa fa-info-circle ml-2" />
            </div>
            <div @click.stop>
              <!-- <button class="btn btn-sm btn-outline-primary" @click.stop="downloadCSV(value)">
              <i class="fa fa-download" />
              Download CSV
            </button> -->
              <button
                class="btn btn-sm btn-outline-success"
                @click="downloadExcel(value)"
                v-if="value.data && value.data.length > 0"
              >
                <i
                  v-if="!value.data && value.isLoading"
                  class="fas fa-spinner reports-list__spinner-icon--rotate"
                />
                <i v-else class="fa fa-download" />&nbsp;
                <span v-label-key="'DOWNLOAD_EXCEL'">Download Excel</span>
              </button>
            </div>
            <b-modal
              :id="`explanations-${key}`"
              :title="reportName(value)"
              ok-only
            >
              <p class="modalClass">{{ reportExplanation(value) }}</p>
            </b-modal>
          </b-card-header>
          <div v-if="value.isExpand">
            <loading-spinner v-if="!value.data && value.isLoading" />
            <report-chart
              v-if="value.data && value.data.length > 0"
              :data="value.data"
              :type="value.type"
              :charttitle="reportName(value)"
              :limit="value.limit"
              :colors="value.colors"
            />
            <b-card-body
              v-if="value.data && value.data.length == 0"
              class="text-center"
            >
              <span v-label-key="'REPORTS_NO_CUTS'"
                >No cuts occurred. Please try a different period.</span
              >
            </b-card-body>
          </div>
        </template>
      </b-card>
    </b-col>

    <b-col md="3">
      <b-card no-body class="mb-3">
        <b-card-header>
          <span v-label-key="'TIME_PERIOD'">Time Period</span>
        </b-card-header>
        <b-card-body>
          <date-range-selector v-model="selectedRange" @refresh="update()" />
        </b-card-body>
      </b-card>
      <b-card no-body>
        <b-card-header>
          <span v-label-key="'REPORTS_CUT_TYPES'">Cut Types</span>
        </b-card-header>
        <b-card-body>
          <b-form-group>
            <b-form-select v-model="cutType">
              <b-form-select-option value="ALL_CUTS">
                <span v-label-key="'REPORTS_CUT_TYPES_ALL'">All Cuts</span>
              </b-form-select-option>
              <b-form-select-option value="STANDARD_CUTS">
                <span v-label-key="'REPORTS_CUT_TYPES_STANDARD'"
                  >Standard Cuts Only</span
                >
              </b-form-select-option>
              <b-form-select-option value="WARRANTY_CUTS">
                <span v-label-key="'REPORTS_CUT_TYPES_WARRANTY'"
                  >Warranty Cuts Only</span
                >
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import $api from "@/services/api";
import $csv from "@/services/csv";
import $excel from "@/services/excel";
import $auth from "@/services/auth";

import { mapGetters } from "vuex";

import DateRangeSelector from "@/components/DateRangeSelector";
import ReportChart from "@/components/ReportChart";
import LoadingSpinner from "@/components/LoadingSpinner";

const failureReasonMap = {
  OTHER_PRINT_ERROR: "FAILURE_REASON_OTHER_PRINT_ERROR",
  INSUFFICIENT_INK: "FAILURE_REASON_INSUFFICIENT_INK",
  NO_CONNECT_PRINTER: "FAILURE_REASON_CANNOT_CONNECT_PRINTER",
  NO_PAPER: "FAILURE_REASON_NO_PAPER",
  PRINT_WRONG_SIZE: "FAILURE_REASON_PRINTED_WRONG_SIZE",
  PRINT_HALF: "FAILURE_REASON_PRINTED_HALF",
  PRINT_OFF_FILM: "FAILURE_REASON_PRINTED_OFF_FILM",
  OTHER_CUT_ERROR: "FAILURE_REASON_OTHER_CUT_ERROR",
  UNABLE_TO_CONNECT: "FAILURE_REASON_CANNOT_CONNECT",
  STOP_PART_WAY: "FAILURE_REASON_CUTTING_STOPPED_PART_WAY",
  NO_CUT_THROUGH: "FAILURE_REASON_NOT_CUT_THROUGH",
  CUT_WRONG_PLACE: "FAILURE_REASON_CUT_WRONG_PLACE",
  CUT_WRONG_SIZE: "FAILURE_REASON_CUT_WRONG_SIZE",
};

const reportLabelsMap = {
  credit: "CREDIT",
  filmcode: "FILM_CODE",
  STARTED: "CUT_STATUS_STARTED",
  PRINT_CONFIRMED: "CUT_STATUS_PRINT_CONFIRMED",
  PRINT_SUCCESS: "CUT_STATUS_PRINT_SUCCESS",
  PRINT_FAILED: "CUT_STATUS_PRINT_FAILED",
  CUT_CONFIRMED: "CUT_STATUS_CUT_CONFIRMED",
  CUT_SUCCESS: "CUT_STATUS_CUT_SUCCESS",
  CUT_FAILED: "CUT_STATUS_CUT_FAILED",
  ...failureReasonMap,
};

export default {
  name: "ReportList", // Exactly one should be specified
  components: {
    DateRangeSelector,
    ReportChart,
    LoadingSpinner,
  },
  /* eslint-disable-next-line vue/prop-name-casing, vue/require-prop-types */
  props: ["distributor_id", "subdistributor_id", "chain_id", "store_id"],
  data() {
    return {
      selectedRange: null,
      reportTypes: null,
      totalCuts: null,
      cutsPerDay: null,
      renderIndex: 1,
      cutType: "ALL_CUTS",
      reportDataLoading: false,
      lastQueryTime: null,
    };
  },
  computed: {
    ...mapGetters("translations", {
      getLabel: "getLabel",
      getReplaceLabel: "getReplaceLabel",
    }),
    topXLabel() {
      return (limit) => {
        this.getReplaceLabel("REPORTS_TOP_X", { "{COUNT}": limit });
      };
    },
    reportExplanation() {
      return (report) => {
        let explanations = report.explanations || [];
        if (report.explanationKeys) {
          explanations = report.explanationKeys.map(this.getLabel);
        }
        return explanations.join("\n");
      };
    },
    level() {
      return (
        (this.distributor_id && 3) ||
        (this.subdistributor_id && 2) ||
        (this.chain_id && 1) ||
        (this.store_id && 0) ||
        $auth.user.selectedAccess.roleLevel
      );
    },
    reportName() {
      return (report) => {
        let reportName = report.name || "";
        if (report.nameKey) {
          reportName = this.getLabel(report.nameKey);
        }
        return reportName;
      };
    },
  },
  watch: {
    cutType() {
      /* eslint-disable no-unused-expressions */
      this.cutType && this.update();
    },
  },
  created() {
    this.refreshData();
  },
  methods: {
    /* eslint-disable */
    async update() {
      if (!this.reportTypes) {
        return false;
      }
      this.reportDataLoading = true;

      Object.values(this.reportTypes).forEach((val) => {
        delete val.data;
        val.isExpand = false;
        val.isLoading = false;
      });
      const payload = this.getReportPayload();
      const reportTypeKeys = Object.keys(this.reportTypes);
      //260618 - temp disable all but the first report to speed up loading while we work on improving performance

      // for (let reportType of reportTypeKeys) {
      // If the query changes, cancel outstanding API calls
      //if (this.lastQueryTime !== queryTime) break;

      this.reportToggleExpand("cuts_by_date"); // default report to load first
      // }
      //----//
      // const promises = Object.keys(this.reportTypes)
      //   .filter((reportType, r) => {
      //     return r < 1;
      //   })
      //   .map(reportType =>
      // );
      // Ensure this is the currently active query before marking as done;
      //if (this.lastQueryTime !== queryTime) return;
      this.reportDataLoading = false;
      this.renderIndex += 1;

      // Promise.all(promises).then(() => {});
    },
    getReportPayload() {
      const payload = {
        distributor_id: this.distributor_id,
        subdistributor_id: this.subdistributor_id,
        chain_id: this.chain_id,
        store_id: this.store_id,
      };
      payload._start = this.selectedRange.start;
      payload._end = this.selectedRange.end;
      payload._tz = this.selectedRange.timezone;
      payload.cuttype = this.cutType;

      return payload;
    },
    refreshData() {
      this.reportDataLoading = true;
      $api
        .get("/v1/dashboard/reports")
        .then((reportTypes) => {
          this.reportTypes = reportTypes;
          this.update();
        })
        .catch((err) => {
          this.reportDataLoading = false;
        });
    },
    async getReportData(request) {
      const { reportType, payload } = request;

      this.lastQueryTime = Date.now();
      const queryTime = this.lastQueryTime;

      this.$set(this.reportTypes[reportType], "isLoading", true);

      await $api
        .get(`/v1/dashboard/reports/${reportType}`, payload)
        .then((data) => {
          // Sort data if required. This should probably be done on the API side
          if (data[0] && data[0].sortindex) {
            data.sort((a, b) => a.sortindex - b.sortindex);
          }
          // Calculate totals
          if (reportType === "cuts_by_date") {
            let totalCuts = 0;
            data.forEach((item) => {
              totalCuts += item.count;
            });
            this.totalCuts = totalCuts;
            const { dayCount } = this.selectedRange;
            this.cutsPerDay = (totalCuts / dayCount).toFixed();
          }
          data.forEach((item) => {
            if (reportLabelsMap[item.name]) {
              const label = this.getLabel(reportLabelsMap[item.name]);
              if (label) {
                const colors = this.reportTypes[reportType].colors;
                if (colors) {
                  const color = colors[item.name];
                  this.reportTypes[reportType].colors[label] = color;
                }
                item.name = label;
              }
            }
          });
          // Check in case the user has changed the filter params.  If they are the same, add the data to the object
          if (queryTime === this.lastQueryTime) {
            // Set the data
            this.$set(this.reportTypes[reportType], "data", data);
          }
        })
        .catch((err) => {
          if (reportType == "cuts_by_date") {
            // alert(err);
          }
          console.log("Failed", err);
          this.reportDataLoading = false;
        })
        .finally(() => {
          this.$set(this.reportTypes[reportType], "isLoading", false);
        });
    },
    reportToggleExpand(key) {
      const isExpand = !this.reportTypes[key].isExpand;

      this.$set(this.reportTypes, key, {
        ...this.reportTypes[key],
        isExpand,
      });

      if (!isExpand) {
        return;
      }

      this.getReportData({
        reportType: key,
        payload: this.getReportPayload(),
      });
    },
    downloadCSV(value) {
      const reportName = this.reportName(value);
      $csv.export(
        value.data,
        [this.getLabel("NAME"), this.getLabel("COUNT")],
        `${reportName}.csv`,
      );
    },
    downloadExcel(value) {
      const reportName = this.reportName(value).slice(0, 31);
      $excel.export(value.data, ["name", "count"], `${reportName}`, [
        this.getLabel("NAME"),
        this.getLabel("COUNT"),
      ]);
    },
    downloadAll() {
      /* eslint-disable */
      const wb = XLSX.utils.book_new();
      Object.keys(this.reportTypes).forEach((reportKey) => {
        const report = this.reportTypes[reportKey];
        const data = [[this.getLabel("NAME"), this.getLabel("COUNT")]];
        report.data.forEach((row) => {
          data.push([row.name, row.count]);
        });
        const ws = XLSX.utils.aoa_to_sheet(data);
        const reportName = this.reportName(report).slice(0, 31);
        XLSX.utils.book_append_sheet(wb, ws, reportName);
      });
      XLSX.writeFile(wb, "output.xlsx");
    },
  },
};
</script>
<style scoped>
.keymetrics {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  text-align: center;
}

.reports-list__spinner-icon--rotate {
  animation-duration: 1s;
  animation-name: rotate;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.card-header {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
}

.card-header.pointer {
  cursor: pointer;
}

.tooltip.b-tooltip {
  pointer-events: none;
}

.toolTipLineBreak >>> .tooltip-inner {
  max-width: 500px;
  width: 490px;
  white-space: pre-wrap;
}
.modalClass {
  white-space: pre-wrap;
  padding: 0 10px;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
